import React from "react";
import Plot from "react-plotly.js";
import {Grid, Header, Table, Container} from "semantic-ui-react";
import _ from "lodash";
import CsvDownload from 'react-json-to-csv'
import DeleteEntryModal from "./DeleteEntryModal";

function QuizGraph(
    {
        studentData,
        quizGraph,
        assignmentNum,
        assignmentData,
        CSVFile,
        dataFetched,
        handleClearAssignmentData,
        totalHintsUsed
    }
) {
    return (
        <>
            <DeleteEntryModal
                page={"Quiz"}
                assignmentNum={assignmentNum}
                handleClearAssignmentData={handleClearAssignmentData}
            />
            {
                assignmentNum ?
                    <div className='statisticsStyle'>
                        <Grid centered={true}>
                            <Grid.Row>
                                <Header as='h1'>
                                    Viewing Quiz Data for Assignment {assignmentNum}
                                </Header>
                            </Grid.Row>
                            <Grid.Row columns={2}>
                                <Grid.Column width={7}>
                                    <Container>
                                        <Header as='h1' textAlign='center'>
                                            Assignment Completion
                                        </Header>
                                        <CsvDownload data={CSVFile} filename={'Quiz_Data_Assignment_' + assignmentNum + '.csv'}/>
                                        <Table celled>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell textAlign='center'>Email</Table.HeaderCell>
                                                    <Table.HeaderCell textAlign='center'>Hints Used</Table.HeaderCell>
                                                    <Table.HeaderCell textAlign='center'>Date Submitted</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {
                                                    _.times(studentData.length, (i) => (
                                                        <>
                                                            <Table.Row>
                                                                <Table.Cell>
                                                                    {studentData[i].email}
                                                                </Table.Cell>
                                                                <Table.Cell textAlign='right' width={1}>
                                                                    {totalHintsUsed[i]}
                                                                </Table.Cell>
                                                                <Table.Cell textAlign='right'>
                                                                    {
                                                                        studentData[i].date[(assignmentNum - 1)] === '' ?
                                                                            "Incomplete"
                                                                            :
                                                                            studentData[i].date[(assignmentNum - 1)]


                                                                    }
                                                                </Table.Cell>

                                                            </Table.Row>
                                                        </>
                                                    ))
                                                }
                                            </Table.Body>
                                        </Table>
                                    </Container>
                                </Grid.Column>
                                <Grid.Column>
                                    <Plot
                                        data={[
                                            {
                                                x: quizGraph.question,
                                                y: quizGraph.attempts,
                                                type: 'bar',
                                                name: "Attempts made",
                                                marker: {color: 'blue'},
                                            },
                                            {
                                                x: quizGraph.question,
                                                y: quizGraph.hint,
                                                type: 'bar',
                                                name: "Hint used",
                                                marker: {color: 'red'},
                                            }
                                        ]}
                                        layout={{
                                            width: 800,
                                            height: 450,
                                            autoSize: true,
                                            title: 'Total attempts/hint made for Assignment ' + assignmentNum,
                                            xaxis: {
                                                title: {
                                                    text: 'Question Number',
                                                    font: {
                                                        size: 18,
                                                        color: 'black'
                                                    }
                                                },
                                                tickangle: -0,
                                                tickmode: 'linear'
                                            },
                                            yaxis: {
                                                title: {
                                                    text: '# attempts/# hint',
                                                    font: {
                                                        size: 18,
                                                        color: 'black'
                                                    }
                                                }
                                            },
                                        }}
                                    />
                                    <Header as='h1' textAlign='center'>
                                        Translation Assignment Total Attempts/Hints Used
                                    </Header>
                                    <Table celled>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell textAlign='center'>Question Number</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center'>English</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center'>Samoan</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center'>Attempts Made</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='center'>Hint Used</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {
                                                _.times(assignmentData.length, (i) => (
                                                    <>
                                                        <Table.Row>
                                                            <Table.Cell textAlign='right' width={1}>
                                                                {(i + 1)}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {assignmentData[i].question}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {assignmentData[i].answer}
                                                            </Table.Cell>
                                                            {
                                                                dataFetched ?
                                                                    <>
                                                                        <Table.Cell textAlign='right' width={1}>
                                                                            {quizGraph.attempts[i]}
                                                                        </Table.Cell>
                                                                        <Table.Cell textAlign='right' width={1}>
                                                                            {quizGraph.hint[i]}
                                                                        </Table.Cell>
                                                                    </>
                                                                    :
                                                                    null
                                                            }

                                                        </Table.Row>
                                                    </>
                                                ))
                                            }
                                        </Table.Body>
                                    </Table>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                    :
                    <Header as='h1' textAlign='center'>Please select an assignment in the Menu tab to see quiz
                        data</Header>

            }

        </>
    )
}

export default QuizGraph
